export default "__VITE_ASSET__7a8c8e75__"